const storage = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  USER: "USER",
};

export default storage;
